import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ListingTimeline } from 'app/models/listing-timeline';
import { fromEvent } from 'rxjs';

@Component({
  selector: 'marketing-banner',
  templateUrl: './marketing-banner.component.html',
  styleUrls: ['./marketing-banner.component.scss']
})
export class MarketingBannerComponent {
  @Output() onClickThrough: EventEmitter<null> = new EventEmitter();
  @Input() listingTimeline: ListingTimeline;
  @Input() position: string;
  @ViewChild('link') link: ElementRef<HTMLElement>;

  constructor() {}

  ngAfterViewInit() {
    fromEvent(this.link.nativeElement, 'click')
      .subscribe(() => {
        this.onClickThrough.emit();
      })
  }

  positionClass(){
    switch (this.position) {
      case 'left':
        return 'justify-content-left'
      case 'center':
        return 'justify-content-center'
      case 'right':
        return 'justify-content-right'
      case 'between':
        return 'justify-content-between'
      default:
        return 'justify-content-left'
    }
  }
}
